module.exports = "pegasus/assets/tech/sale/100.png";